// =====================================
//
//   付款結果 Controller
//   Author: Gray
//   createtime: 2016 / 09 / 27
//	 updatetime: 2016 / 09 / 27
//
// =====================================

window.InifECMobileApp.controller("PaymentSinopacATMController", ['$scope', '$state', '$timeout', 
    '$rootScope', '$stateParams', 'UserService', 'OrderService',
	function($scope, $state, $timeout, 
        $rootScope, $stateParams, UserService, OrderService) {

        var getOrderInfo = function() {

            if($scope.isLoading) {
                return;
            }

            $scope.isLoading = true;
            OrderService.getOrderInfo($scope.orderid).then(function(result) {
                if(result) {

                    $scope.order = result;

                    // 如果不是審查合格狀態則踢掉
                    if($scope.order.orderstatus != 250 && $scope.order.orderstatus != 300){
                        $scope.isLoading = false;
                        $scope.isStatusError = true;
                    } else {
                        pay();
                    }
                    
                } else {
                    $scope.isLoading = false;
                    $scope.isError = true;
                }

            }, function(error) {

                if(error && (error.code == 'error.rscNotExist' || error.code == 'error.privilege.noReadable')) {
                    $scope.isOrderNotExist = true;
                }

                $scope.isError = true;                
                $scope.isLoading = false;
            });
        }

        var pay = function() {

            if(!$scope.order) {
                $scope.isError = true;
                return;
            }

            var orderid = $scope.orderid,
                paymentmethod = Paytype_SinopacATM,
                totalamount = $scope.order.totalamount;

            OrderService.payForOrder(orderid, paymentmethod, totalamount).then(function(result) {
                if(result && result.logs && result.logs.length > 0) {
                    // 處理ATM資料
                    try {

                        var alllogs = result.logs;

                        for(var i = 0; i < alllogs.length; i++){
                            var logid = alllogs[i][0];
                            if(logid.paytype == Paytype_SinopacATM) {
                                var log = alllogs[i][1]

                                $scope.atminfo = angular.fromJson(log.gatewayRstJSON);
                                break;
                            }
                        }
                        
                    } catch (e) {
                        console.log(e);
                        $scope.isError = true;
                        $scope.isLoading = false;
                        return;
                    }

                    $scope.isLoading = false;
                    $scope.isError = false;
                    $scope.isComplete = true;
                } else {
                    $scope.isError = true;
                    $scope.isLoading = false;
                }             
            }, function(error) {
                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        var init = function() {
            
            UserService.getUserInfo().then(function(result) {
                $scope.isLogin = true;

                getOrderInfo();
            }, function(error) {
                $scope.isNoLogin = true;
                $scope.isLoading = false;
            });
        }

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.orderid = $stateParams.orderid;
        $scope.order;
        $scope.atminfo;
        $scope.isError = false;
        $scope.isNoLogin = false;
        $scope.isLoading = false;
        $scope.isComplete = false;
        $scope.isOrderNotExist = false;
        $scope.isOverError = false;
        $scope.isStatusError = false;

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);